import imageCosecha from "../images/products/markus-spiske-sFydXGrt5OA-cosecha.jpeg";
import imagePosCosecha from "../images/products/nina-luong-dp06f70Eyvc-poscosecha.jpeg";
import imagePecuario from "../images/products/ben-moreland-8wWpDF4Av-Y-pecuario.jpeg";
import imageColchon from "../images/products/divazus-fabric-store-65v80luxKRM-colchones.jpeg";
import imageConstruccion from "../images/products/sven-brandsma-kerFMg52cUA-construccion.jpeg";

export const ApplicationsMessages = {
  cosecha: {
    imagePath: `${imageCosecha}`,
    description: "Cosecha, como biopesticida.",
    credits: (
      <div>
        Foto de:
        <a
          href="https://unsplash.com/es/@markusspiske?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
          target="_blank"
          rel="noopener noreferrer"
        >
          Markus Spiske
        </a>
        , en:
        <a
          href="https://unsplash.com/es/fotos/persona-que-riega-la-planta-sFydXGrt5OA?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
          target="_blank"
          rel="noopener noreferrer"
        >
          Unsplash
        </a>
      </div>
    ),
    title: "Cultivos",
  },
  poscosecha: {
    imagePath: `${imagePosCosecha}`,
    description: "Poscosecha, como biopesticida en residuos de palma.",
    credits: (
      <div>
        Foto de:
        <a
          href="https://unsplash.com/es/@ninaluong?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
          target="_blank"
          rel="noopener noreferrer"
        >
          Nina Luong
        </a>
        , en:
        <a
          href="https://unsplash.com/es/fotos/verduras-naranjas-y-verdes-en-una-canasta-tejida-marron-dp06f70Eyvc?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
          target="_blank"
          rel="noopener noreferrer"
        >
          Unsplash
        </a>
      </div>
    ),
    title: "Poscosecha",
  },
  pecuario: {
    imagePath: `${imagePecuario}`,
    description:
      "Pecuario, como detergente para reducir la prevalencia de infecciones fúngicas y bactericidas en las aves.",
    credits: (
      <div>
        Foto de:
        <a
          href="https://unsplash.com/es/@relentlessjpg?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
          target="_blank"
          rel="noopener noreferrer"
        >
          Ben Moreland
        </a>
        , en:
        <a
          href="https://unsplash.com/es/fotos/cinco-gallinas-marrones-en-el-suelo-junto-a-la-valla-8wWpDF4Av-Y?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
          target="_blank"
          rel="noopener noreferrer"
        >
          Unsplash
        </a>
      </div>
    ),
    title: "Pecuario",
  },
  colchones: {
    imagePath: `${imageColchon}`,
    description:
      "Industria de fabricación de colchones y espumas como agente antifúngico y bactericida.",
    credits: (
      <div>
        Foto de:
        <a
          href="https://unsplash.com/es/@divazus?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
          target="_blank"
          rel="noopener noreferrer"
        >
          Divazus Fabric Store
        </a>
        , en:
        <a
          href="https://unsplash.com/es/fotos/una-vista-de-cerca-de-una-manta-blanca-vK9eZ1CvRLM?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
          target="_blank"
          rel="noopener noreferrer"
        >
          Unsplash
        </a>
      </div>
    ),
    title: "Colchones",
  },
  construccion: {
    imagePath: `${imageConstruccion}`,
    description:
      "Construcción, como aditivo para reducir el desarrollo de hongos en las estructuras.",
      credits: (
        <div>
          Foto de:
          <a
            href="https://unsplash.com/es/@seffen99?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
            target="_blank"
            rel="noopener noreferrer"
          >
            Sven Brandsma
          </a>
          , en:
          <a
            href="https://unsplash.com/es/fotos/lata-azul-y-blanca-sobre-mesa-blanca-kerFMg52cUA?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
            target="_blank"
            rel="noopener noreferrer"
          >
            Unsplash
          </a>
        </div>
      ),
    title: "Construcción",
  },
};    